import React from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import { FooterProps } from '../index'
import ShopperApprovedWidget from '#src/components/Reviews/ShopperApprovedWidget'
import Copyright from '#src/components/Copyright'
import SocialMediaLink, { SocialMedia } from '#src/components/SocialMediaLink'
import BrandAwareLogo from '#src/components/Logo'
import PageContent from '#src/components/PageContent'
import sections from './data'
import styles from './styles.css'

const Footer: React.SFC<FooterProps> = ({ className, sidebar, hideWidget }) => (
  <footer className={classnames(styles.sectionLight, className)}>
    <PageContent sidebar={sidebar}>
      <div className={styles.flexResponsive}>
        <div className={styles.flexResponsiveInverse}>
          {!hideWidget && <ShopperApprovedWidget />}

          <Link to="/" className={styles.logo}>
            <BrandAwareLogo color="dark" mark="icon" />
          </Link>
          <div className={styles.copywrite}>
            <Copyright />
          </div>
        </div>
        <div className={styles.optionsContainer}>
          {sections.map(({ label, links }) => (
            <div key={label} className={styles.group}>
              <div className={styles.groupTitle}>{label}</div>
              {links.map(({ label, link, isSocial }) =>
                isSocial ? (
                  <SocialMediaLink
                    key={label}
                    target="_blank"
                    className={styles.groupItem}
                    socialMedia={link as SocialMedia}
                  >
                    {label}
                  </SocialMediaLink>
                ) : (
                  <Link key={label} to={link} className={styles.groupItem}>
                    {label}
                  </Link>
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </PageContent>
  </footer>
)

export default Footer
